import Marquee from "react-fast-marquee";
import Image from 'react-bootstrap/Image';
import SIBanner from '../../assets/Image/si-2024-banner.png';
import RETBanner from '../../assets/Image/ret-2024-banner.png';
import NanoNewsBanner from '../../assets/Image/nanonews-banner.png';

const ImageMarquee = () => (
    <Marquee speed={140} pauseOnClick={true}>
        <div style={{ "display": "flex", "justify-content": "space-evenly" }}>
            <div style={{ "margin-left": "70vh",  "margin-right": "70vh" }}>
                <a href={"/programs/summer-institute"}>
                    <Image width={1050} height={420} src={SIBanner} fluid />
                </a>
            </div>
            <div style={{ "margin-left": "70vh",  "margin-right": "70vh" }}>
                <a href={"/programs/ret"}>
                    <Image width={1050} height={420} src={RETBanner} fluid />
                </a>
            </div>
            <div style={{ "margin-left": "70vh",  "margin-right": "70vh" }}>
                <a href={"/news/ca"}>
                    <Image width={1050} height={420} src={NanoNewsBanner} fluid />
                </a>
            </div>
        </div>
    </Marquee>
);

export default ImageMarquee;